export default __webpack_public_path__ + "static/media/sp_card_setting.78a7d7ba.svg";